import {Container, Ticker} from "pixi.js";
import * as PIXI from "pixi.js";
import { Timer } from "./Timer";

export class DebugOverlay {
	// public fps: PIXI.Text;
	// private ticker: Ticker;
	// private timer: Timer = new Timer();

	public constructor(parent: Container, ticker: Ticker) {
		// this.ticker = ticker;
		// this.fps = new PIXI.Text();
		// parent.addChild(this.fps);
	}

	public tick(deltaMS: number) {
		// this.timer.tick(deltaMS);
		// if (this.timer.elapsed > 1) {
		// 	this.fps.text = `${Math.round(this.ticker.FPS)}/${this.ticker.maxFPS} fps`;
		// 	this.timer.reset();
		// }
	}
}
